import React from "react";

interface Device {
  id: string;
  name: string;
  specs: string;
  price: number;
}

interface BrandGroup {
  brand: string;
  devices: Device[];
}

interface HandyPlaceholderProps {
  searchQuery?: string;
  onSelect?: (device: Device) => void;
}

export const mockSmartphones: BrandGroup[] = [
  {
    brand: "APPLE",
    devices: [
      { id: "1", name: "iPhone 15", specs: "128GB", price: 699.0 },
      { id: "2", name: "iPhone 16", specs: "128GB", price: 799.0 },
      { id: "3", name: "iPhone 16", specs: "256GB", price: 899.0 },
      { id: "4", name: "iPhone 16 Plus", specs: "128GB", price: 949.0 },
      { id: "5", name: "iPhone 16 Pro", specs: "128GB", price: 1099.0 },
    ],
  },
  {
    brand: "GOOGLE",
    devices: [
      { id: "6", name: "Pixel 8a", specs: "128GB", price: 499.0 },
      { id: "7", name: "Pixel 9", specs: "128GB", price: 749.0 },
      { id: "8", name: "Pixel 9 Pro", specs: "128GB", price: 899.0 },
    ],
  },
  {
    brand: "SAMSUNG",
    devices: [
      { id: "9", name: "Galaxy Z Flip6", specs: "256GB", price: 1049.0 },
      { id: "10", name: "Galaxy A55", specs: "128GB", price: 349.0 },
    ],
  },
  {
    brand: "XIAOMI",
    devices: [
      {
        id: "11",
        name: "Redmi Note 13 Pro",
        specs: "256GB",
        price: 399.0,
      },
      { id: "12", name: "Xiaomi 14", specs: "512GB", price: 999.0 },
    ],
  },
  {
    brand: "SONY",
    devices: [{ id: "13", name: "Xperia 1 VI", specs: "256GB", price: 1399.0 }],
  },
];

function HandyPlaceholder({
  searchQuery = "",
  onSelect,
}: HandyPlaceholderProps) {
  const filteredSmartphones = mockSmartphones
    .map((group) => ({
      ...group,
      devices: group.devices.filter((device) =>
        device.name.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    }))
    .filter((group) => group.devices.length > 0);

  return (
    <div className="device-table">
      <table className="device-table__table">
        <thead>
          <tr className="device-table__header-row">
            <th className="device-table__header-cell device-table__header-cell--name">
              Gerät
            </th>
            <th className="device-table__header-cell device-table__header-cell--specs">
              Specs
            </th>
            <th className="device-table__header-cell device-table__header-cell--price">
              EK(Netto)
            </th>
            <th className="device-table__header-cell device-table__header-cell--action">
              Aktion
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredSmartphones.map((group) => (
            <React.Fragment key={group.brand}>
              <tr className="device-table__brand-row">
                <td colSpan={4}>
                  <div
                    className={`device-table__brand-label device-table__brand-label--${group.brand.toLowerCase()}`}
                  >
                    {group.brand}
                  </div>
                </td>
              </tr>
              {group.devices.map((device) => (
                <tr key={device.id} className="device-table__row">
                  <td className="device-table__cell device-table__cell--name">
                    {device.name}
                  </td>
                  <td className="device-table__cell device-table__cell--specs">
                    {device.specs}
                  </td>
                  <td className="device-table__cell device-table__cell--price">
                    {new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                    }).format(device.price)}
                  </td>
                  <td className="device-table__cell device-table__cell--action">
                    <button
                      className="device-table__btn-select"
                      onClick={() => onSelect?.(device)}
                    >
                      Wählen
                    </button>
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
          {filteredSmartphones.length === 0 && (
            <tr>
              <td
                colSpan={4}
                style={{ textAlign: "center", padding: "2rem", color: "#999" }}
              >
                Keine Geräte gefunden
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default HandyPlaceholder;
